import * as React from 'react';
import MuiInputBase, { InputBaseProps as MuiInputBaseProps } from '@mui/material/InputBase';
import { BpDesignSystem } from '../../types';

export type InputBaseProps = BpDesignSystem.Props<Omit<MuiInputBaseProps, 'color' | 'variant' | 'select'>>;

export const InputBase = React.forwardRef<HTMLDivElement, InputBaseProps>(({ dataTest, ...inputBaseProps }, ref) => {
  return <MuiInputBase ref={ref} data-test={dataTest} {...inputBaseProps} />;
});
